const zh = {
  产品菜单: '产品',
  关于我们菜单: '关于我们',
  帮助中心菜单: '帮助中心',
  信用基础: '信用为基',
  加密支付: '加密支付',
  全币种支持: '全币种支持',
  全节点承兑: '全节点承兑',
  去中心担保: '去中心担保',
  立即开始使用: '立即开始使用',
  闪电般的支付体验: '闪电般的支付体验',
  完成跨境支付: '45秒内完成跨境支付',
  多链支持: '多链支持',
  支持主流公链资产: '支持主流公链资产',
  实时结算: '实时结算',
  无需等待: '秒级到账，无需等待',
  超额担保: '超额担保',
  资金安全有保障: '资金安全有保障',
  一个钱包: '一个钱包',
  所有可能: '所有可能',
  商户收款: '商户收款',
  全球化支付网关: '全球化支付网关',
  承兑服务: '承兑服务',
  稳定可靠的承兑网络: '稳定可靠的承兑网络',
  数字资产: '数字资产',
  多链资产管理: '多链资产管理',
  下载: 'App下载',
  多节点承兑: '多节点承兑',
  全币种支持: '全币种支持',
  去中心担保: '去中心担保',
  生态: 'NECO 生态',
  钱包: 'TEPAY Wallet',
  立即下载: '立即下载',
  随时汇币: '随时随地币支付跨国汇款不再难',
  一个钱包: '一个钱包',
  走天下: '走天下',
  海量订单: '海量订单',
  日进斗金: '日进斗金',
  首页描述: 'TePay是一个去中心化的信用支付基础设施，不是银行。金融服务由我们的接受节点网络和基于区块链的智能合约网络提供支持。抵押和信用机制确保安全合规的交易，而托管和争议解决则通过我们的DAO仲裁系统进行管理。多链互操作性和集成合规模块为用户提供无缝、透明的支付体验，无论是用户还是商家。',
  轻松交易: '轻松交易',
  slide2Text: '通过 TePay 去中心化的多节点网络，实现法币与数字货币的自由、无缝兑换',
  slide2Info: 'TePay 是一个去中心化的支付平台，而非传统银行。服务由我们的多节点承兑网络提供，并通过区块链智能合约加以保障。超额抵押和信用评分机制确保每笔交易都合规且安全。',
  全球通用: '全球通用',
  让每一笔支付: '让每一笔支付',
  瞬间达成: '瞬间达成',
  slide3Text: '在 TePay 强大的网络中，自由交易法币与数字货币。',
  slide3Info: 'TePay 不局限于单一货币。我们的去中心化平台让您轻松发送、接收并兑换多种货币，打破国界限制，享受统一体验。借助区块链技术和动态信用机制，您的资金始终安全高效地运转。',
  护航每笔交易: '护航每笔交易',
  去中心化担保: '去中心化担保',
  安全无忧: '安全无忧',
  slide4Text: '通过去中心化担保机制，为每笔交易提供信任保障与安全支持。',
  slide4Info: 'TePay 并非传统银行，而是通过去中心化担保机制确保交易安全。我们的系统利用超额抵押、动态信用评分和 DAO 仲裁，为每笔交易提供坚实保障。这一强大的担保机制有效连接传统金融与数字资产，确保所有支付均合规、安全、高效。',
  一个钱包走天下: '一个钱包走天下',
  币随时付: '币随时付',
  跨境无忧: '跨境无忧',
  slide5Text: '一站式管理所有资产，无论法币还是数字货币，尽在一个安全钱包中。',
  slide5Info: 'TePay 将您的金融世界融为一体，通过一个钱包解决所有支付需求。我们的平台整合资产管理与全球交易，依托先进区块链技术和动态信用机制，为您提供无缝、高效的金融体验。',
  海量订单: '海量订单',
  海量订单: '日进斗金',
  slide6Text: '对接商户与客户多元币种需求，获利无限。',
  slide6Info: 'TePay 的动态匹配引擎打通法币与数字币之间的壁垒，使承兑节点无论在商户还是客户采用哪种币种时，都能实现盈利。平台高效结算，每笔交易均助您收益倍增。',
  边兑边赚: '边兑边赚',
  信用随行: '信用随行',
  slide7Text: '每次兑换都让您收益倍增，同时信用稳步提升。',
  slide7Info: 'TePay 并非传统银行，而是通过去中心化担保机制确保交易安全。我们的系统利用超额抵押、动态信用评分和 DAO 仲裁，为每笔交易提供坚实保障。这一强大的担保机制有效连接传统金融与数字资产，确保所有支付均合规、安全、高效。',
  下载TEPAY: '下载TEPAY',
  开启信用支付: '开启信用支付',
  多币种支持: '多币种支持',
  多节点承兑描述: '多节点承兑',
  下载Text: '下载',
  链上赋能: '链上赋能 社区电商',
  品牌即社区: '品牌即社区',
  消费即投资: '消费即投资',
  本地即全球: '本地即全球',
  首页描述: 'NECO（来客）社区电商平台以 Web3 去中心化信任框架为基底，将真实消费与链上透明返利深度融合，重塑用户、商户与社区的价值循环，开创共享、可信、可持续的新电商范式。',
  真实消费: '真实消费',
  支撑返利: '支撑返利',
  slide2Text: '买得越多，返得越真',
  slide2Info: 'NECO 只在 订单已完成并链上确认 后，才生成对应债券和积分；返利额度严格锚定商家让利 20 %，无任何超发。这意味着平台的全部奖励都由 真实现金流 支付，用户看到的每一笔 NECO／USAI 都可在区块浏览器溯源，彻底隔绝“资金盘”风险。',
  透明积分: '透明积分',
  代币经济: '代币经济',
  slide3Text: '积分上链，价值可验',
  slide3Info1: '消费返利被拆分为 NECO 平台币 与 USAI 稳定币 两条账本：',
  slide3Info2: '前者每日 0.2 % 线性释放，后者随销毁／铸造自动平衡汇率。',
  slide3Info3: '所有铸造、销毁、释放事件都由智能合约记录，任何人可实时查看 钱包余额、释放倒计时与历史交易，让每一份激励都拥有公开的“身份证”。',
  多角色: '多角色',
  激励生态: '激励生态',
  slide4Text1: '用户、团长、商户，共赢闭环',
  slide4Info1: '用户：消费返还 100 % 积分，持 NECO 享涨幅与治理权；',
  slide4Info2: '团长：组织团购、运营社群，拿佣金 + NECO 额外奖励；',
  slide4Info3: '商户：让利换精准订单，享 0 手续费结算与品牌曝光。',
  slide4Info4: '三方收益都写进同一套链上公式，收入与付出实时对账，形成自驱动的裂变循环',
  合规保障: '合规保障',
  全程可审: '全程可审',
  slide5Text: '链上留痕，监管友好',
  slide5Info1: 'TePay 网关承担 KYC、法币对接与支付合规；交易数据、让利比例、积分分配全部链上存证。',
  slide5Info2: '平台还设置 双预言机、价格缓冲区与 DAO 风控基金，在出现极端行情或政策变动时，可由治理投票触发限速、回购或暂停机制——让监管放心、用户安心、生态长青。',
  合作伙伴: '合作伙伴',
  社区团购: '社区团购',
  社区小店: '社区小店',
  社区空间: '社区空间',
  社区服务: '社区服务',
  NECO优选: 'NECO优选',
  暂未开放: '暂未开放',
  新闻标题: 'News Center',
  新闻1标题: '创世启动、APP上线和会员系统开放时间的公告',
  新闻1内容: '各位社区成员：\n' +
    '\n' +
    '我们预计于8月5日24点（GMT+8）在Novai SWAP中开放NECO/nUSDT、USAI/nUSDT交易对，完成平台币和稳定币的创世启动。\n' +
    '\n' +
    '同时，NECO APP将正式开放注册，并上线全球会员系统，您可以在该系统中完成以下操作：\n' +
    '1、用户注册和链接分享。\n' +
    '2、将USDT充值到预充值账户成为USAI，并购买VIP会员。\n' +
    '3、创世节点和普通节点等额积分释放（获得NECO收益）。\n' +
    '4、获得会员推荐及其团队积分奖励，管理自己的团队。\n' +
    '5、消费积分（购买会员、团队奖励和节点奖励所得）释放为NECO。\n' +
    '6、NECO闪兑成USAI并提现（当前版本支持提现为USDT）。\n' +
    '7、消费返股的基础功能（查看NECO币价、查看SWAP NECO交易兑、查看公告等）。\n' +
    '\n' +
    '如遇时间调整，我们将另行公告。',
  返回: '返回',
  消费返股: '消费返股 社区电商',
  全球首个: '全球首个',
  WEB3社区电商平台: 'WEB3社区电商平台',
  消费: '消费',
  赚钱: '赚钱',
  持股: '持股',
  合伙人: '合伙人',
  用户: '用户',
  股东: '股东',
  不只是电商: 'NECO 不只是电商',
  更是社区电商: '更是社区电商',
  共赢闭环: '用户、团长、商户，共赢闭环',
  用户描述: '用户：消费返还 100 % 积分，持 NECO 享涨幅与治理权；',
  团长描述: '团长：组织团购、运营社群，拿佣金 + NECO 额外奖励；',
  商户描述: '商户：让利换精准订单，享 0 手续费结算与品牌曝光。',
  三方描述: '三方收益都写进同一套链上公式，收入与付出实时对账，形成自驱动的裂变循环。',
  购物聊天: 'NECO AI 电商，让购物像聊天一样简单',
  边聊边选:'边聊边选',
  聊天助手实时理解你的对话:'AI 聊天助手实时理解你的对话，',
  就能找到你要的东西:'一句话，就能找到你要的东西。',
  AI优选:'AI优选',
  的那一刻:'你打开 NECO 的那一刻，',
  已经在等你:'最适合你的商品和服务，已经在等你。',
  时尚分身:'时尚分身',
  监控价格:'替你找好物、监控价格、',
  守护你的消费体验:'守护你的消费体验。',
  三类团购机制:'三类团购机制',
  附近团:'附近团',
  熟人团:'熟人团',
  优选团:'优选团',
  全球战略布局:'全球战略布局',
  使命与愿景:'NECO 的使命与愿景',
  使命:'使命',
  愿景:'愿景',
  使命描述:'建立公平、透明、可参与的自组织商业系统',
  愿景描述:'让世界上每一个角落都能点亮一盏社区经济之光',
  "公告": "公告",
  "铸造销毁协议": "铸造销毁协议",
  "SWAP交易": "SWAP交易",
  "NECO社区电商": "NECO社区电商",
  "菜单": "菜单",
  "安卓下载": "安卓下载",
  "ios下载": "ios下载",
  "NECO下载": "NECO APP 下载",
  "支持版本": "支持 IOS Android 版本",
  "当前版本": "当前版本",
  "跨链桥": "跨链桥",
  "合作伙伴关系": "合作伙伴关系",
  "请加入社交媒体信息": "请加入社交媒体信息",
  "联系我们": "联系我们",
  "版权所有（公司）": "版权所有（公司）",
  "联系我们的邮件请填写": "联系我们的邮件请填写",
  "新闻": "新闻",
  "网页直连": "网页直连",
  "铸造与销毁协议": "铸造与销毁协议",
  "更多": "更多",
  "请通过": "请通过",
  "与我们联系": "与我们联系",
  "版权所有": "版权所有",
  "联系": "联系",
  "智能体": "智能体",
  "重新定义消费的价值": "重新定义消费的价值",

  "全球首个": "全球首个",
  "WEB3社区电商平台": "WEB3社区电商平台",
  "消费": "消费",
  "持股": "持股",
  "升值": "升值",
  "重新定义消费的价值": "重新定义消费的价值",
  "让消费成为财富的起点": "让消费成为财富的起点",
  "消费即拥有，分享即收益": "消费即拥有，分享即收益",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。",
  "核心技术": "核心技术",
  "基于 Novai Chain 的二层网络": "基于 Novai Chain 的二层网络",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco Chain 将电商的每笔消费行为与激励记录上链，",
  "让商业行为具备长期可验证性与可追溯性。": "让商业行为具备长期可验证性与可追溯性。",
  "高速并行账本结构": "高速并行账本结构",
  "智能结算与动态费用调节": "智能结算与动态费用调节",
  "消费凭证 NFT 化与积分资产化": "消费凭证 NFT 化与积分资产化",
  "核心特性": "核心特性",
  "链上结算": "链上结算",
  "每笔电商交易 0.2 秒确认，安全透明": "每笔电商交易 0.2 秒确认，安全透明",
  "激励协议": "激励协议",
  "激励消费者、商家、渠道等为NECO做出贡献": "激励消费者、商家、渠道等为NECO做出贡献",
  "权益积分": "权益积分",
  "用户消费即持有可追踪、可变现的权益积分": "用户消费即持有可追踪、可变现的权益积分",
  "共建共享": "共建共享",
  "首个去中心商业自治组织，共建共享NECO电商": "首个去中心商业自治组织，共建共享NECO电商",
  "主要产品": "主要产品",
  "支持电商 RWA 的高性能公链": "支持电商 RWA 的高性能公链",
  "稳定币、DEX、去中心信用等电商基础协议": "稳定币、DEX、去中心信用等电商基础协议",
  "同时为WEB2和WEB3用户服务的电商APP": "同时为WEB2和WEB3用户服务的电商APP",
  "法币和数字货币统一支付及结算体系": "法币和数字货币统一支付及结算体系",
  "竞争优势": "竞争优势",
  "极速公链": "极速公链",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "0.2 秒出块，支持百万级并发订单及支付交易。",
  "全球合规": "全球合规",
  "在全球各地通过 DAO 组织进行本地合规运营。": "在全球各地通过 DAO 组织进行本地合规运营。",
  "电商 RWA": "电商 RWA",
  "第一个将现实世界电商完全放在链上运行的平台。": "第一个将现实世界电商完全放在链上运行的平台。",
  "商业闭环": "商业闭环",
  "让消费、社交与收益形成价值闭环。": "让消费、社交与收益形成价值闭环。",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "全球分销体系让每个用户都能成为品牌的传播者与收益方。",
  "消费者端": "消费者端",
  "注册/消费即得积分奖励，积分每日释放为资产。": "注册/消费即得积分奖励，积分每日释放为资产。",
  "商家端": "商家端",
  "一键接入结算 API，设置折让比例与积分政策。": "一键接入结算 API，设置折让比例与积分政策。",
  "分销端": "分销端",
  "允许全球用户参与分销，共享收益与品牌成长。": "允许全球用户参与分销，共享收益与品牌成长。",
  "NECO 生态系统": "NECO 生态系统",
  "一个融合金融、科技与商业的去中心化生态。": "一个融合金融、科技与商业的去中心化生态。",
  "Neco Chain 公链": "Neco Chain 公链",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。",
  "NECO App": "NECO App",
  "用户购物、签到、邀请与分销的统一入口。": "用户购物、签到、邀请与分销的统一入口。",
  "USAI 稳定币": "USAI 稳定币",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "用于平台内支付与结算的稳定币资产，锚定美元价值。",
  "U Card 全球消费卡": "U Card 全球消费卡",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "连接线上线下消费场景，支持积分抵扣与现金返还。",
  "NECO AI 智能系统": "NECO AI 智能系统",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "通过 AI 分析用户行为，实现个性化推荐与安全风控。",
  "消费金融该协议": "消费金融该协议",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "提供通用的去中心化金融基础设施，支持电商资产流通。",
  "稳定币生态": "稳定币生态",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "构建覆盖支付、结算与跨境流通的稳定币网络。",
  "团队及投资人": "团队及投资人",
  "全球化视野 · 多元化背景。": "全球化视野 · 多元化背景。",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。",
  "投资人": "投资人",
  "运营团队": "运营团队",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "曾任职OKX，负责公司品牌和战略",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "Novai Chain Founder， 全面支撑NECO技术落地。",
  "官方路线图": "官方路线图",
  "2025 — 创世与启动": "2025 — 创世与启动",
  "2025 — 增长与市场拓展": "2025 — 增长与市场拓展",
  "2026 — 生态深化与 AI 赋能": "2026 — 生态深化与 AI 赋能",
  "上半年（Q2–Q3）": "上半年（Q2–Q3）",
  "完成白皮书、制度模型与产品原型开发": "完成白皮书、制度模型与产品原型开发",
  "组织九大社区进行创世启动": "组织九大社区进行创世启动",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池",
  "发布 NECO APP BETA 测试版": "发布 NECO APP BETA 测试版",
  "下半年（Q3–Q4）": "下半年（Q3–Q4）",
  "全球社区运营中心部署完成": "全球社区运营中心部署完成",
  "NECO 优选店铺与创世商户上线": "NECO 优选店铺与创世商户上线",
  "推动注册用户突破 10 万": "推动注册用户突破 10 万",
  "启动空投及全球电商启动大会": "启动空投及全球电商启动大会",
  "Q4：好货推广 & 本地电商": "Q4：好货推广 & 本地电商",
  "上线「好货系统」并开放会员商家入驻": "上线「好货系统」并开放会员商家入驻",
  "在主要国家开通 TePay 法币支付": "在主要国家开通 TePay 法币支付",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "完成中国、韩国、越南 10 家 NECO Best 本地电商落地",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "海外注册用户突破 50 万，VIP 用户突破 5 万",
  "举办第二次社区电商大会，开放跨境卖家注册": "举办第二次社区电商大会，开放跨境卖家注册",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "拓展中东、南美、非洲与欧洲本地市场，整合供应链",
  "注册用户突破 100 万，VIP 用户突破 10 万": "注册用户突破 100 万，VIP 用户突破 10 万",
  "Q1–Q2：体系完善": "Q1–Q2：体系完善",
  "跨境卖家突破 10 万，商家数量超 10 万": "跨境卖家突破 10 万，商家数量超 10 万",
  "举办第一届 NECO 电商生态大会": "举办第一届 NECO 电商生态大会",
  "上线稳定币生态与信用体系": "上线稳定币生态与信用体系",
  "注册用户突破 500 万，VIP 超过 20 万": "注册用户突破 500 万，VIP 超过 20 万",
  "Q3–Q4：智能升级": "Q3–Q4：智能升级",
  "获得主要国家支付牌照，全面上线法币支付服务": "获得主要国家支付牌照，全面上线法币支付服务",
  "上线 AI 选品与推荐功能": "上线 AI 选品与推荐功能",
  "商家信用、积分全面上链": "商家信用、积分全面上链",
  "NECO Best 优选商家突破 100 家": "NECO Best 优选商家突破 100 家",
  "注册用户突破 1000 万，VIP 超过 50 万": "注册用户突破 1000 万，VIP 超过 50 万",
  "加入 NECO": "加入 NECO",
  "消费创造财富，社区共建共享。": "消费创造财富，社区共建共享。",
  "一分钟带你了解NECO": "一分钟带你了解NECO",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。",
  "用户与商家共享增长红利。": "用户与商家共享增长红利。",
  "全球版": "全球版",
  "中国版": "中国版",
}
export default zh



// WEBPACK FOOTER //
// ./src/i18n/config/zh.js